const updates = [
    {
        id: 1,
        title: "🎰 Casino Mini-Games",
        date: "Feb 6, 2026",
        tag: "Gaming",
        color: "#f59e0b",
        description: "New games! Coinflip, Slots, Blackjack and Roulette. Bet your money and test your luck. Do you dare?"
    },
    {
        id: 2,
        title: "🎁 Giveaway System",
        date: "Feb 6, 2026",
        tag: "Feature",
        color: "#10b981",
        description: "Create giveaways with !giveaway. Users react to enter. Includes reroll and manual end."
    },
    {
        id: 3,
        title: "🎫 Ticket System",
        date: "Feb 6, 2026",
        tag: "Support",
        color: "#8b5cf6",
        description: "Professional support with !ticket. Creates private channels to help your users one on one."
    },
    {
        id: 4,
        title: "Backend v2.0 - MongoDB & Levels ⚡",
        date: "Feb 6, 2026",
        tag: "Major Update",
        color: "#10b981",
        description: "Complete migration to MongoDB Atlas. Levels and XP system, persistent cooldowns, and advanced moderation."
    },
    {
        id: 5,
        title: "Levels System ⭐",
        date: "Feb 6, 2026",
        tag: "Feature",
        color: "#8b5cf6",
        description: "Earn XP for every message. Level up and get rewards. Use !level and !leaderboard."
    },
    {
        id: 6,
        title: "Daily Reward 🎁",
        date: "Feb 6, 2026",
        tag: "Economy",
        color: "#f59e0b",
        description: "Use !daily once every 24 hours to receive between $200 and $500."
    },
    {
        id: 7,
        title: "Advanced Moderation 🛡️",
        date: "Feb 6, 2026",
        tag: "Moderation",
        color: "#ef4444",
        description: "New commands: !mute, !unmute, !ban, !unban, !kick, !slowmode."
    },
    {
        id: 8,
        title: "Liquid Glass UI 2.0 🖤",
        date: "Feb 5, 2026",
        tag: "Design",
        color: "#5865F2",
        description: "Complete redesign with Liquid Black aesthetic. Sliding navbar, magnetic stars, and Toast notifications."
    },
    {
        id: 9,
        title: "Web Launch 🌐",
        date: "Feb 4, 2026",
        tag: "System",
        color: "#5865F2",
        description: "Official launch of the web interface. Live monitoring and integrated command list."
    }
];

export default updates;
